import { PickingInfo } from '@deck.gl/core/typed';
import styles from '../pages/Map/DeckGl/DeckGlMap.module.scss';
import moment from 'moment';
import { t } from 'i18next';
import i18n from 'resources/i18n';

export const getTooltipDeckGl = (info: PickingInfo, zoom: number, timeFormat: string, isLocalTz?: boolean) => {
  let html = null;
  const lastUpload = moment(info.object?.t);
  const isDataOld = moment().diff(lastUpload, 'second') >= 3600;
  const langValue = i18n.language;
  if (info?.object) {
    if (info?.layer?.id.includes('special-areas-mvt-layer')) {
      if (langValue === 'ru' && info?.object?.properties?.['name(ru)']) {
        html = `<div>${info.object.properties['name(ru)']}</div>`;
      } else if (info?.object?.properties?.name) {
        html = `<div>${info.object.properties.name}</div>`;
      }
    }
    if (info?.layer?.id === 'areas-polygon-layer') {
      if (info?.object?.properties?.name) {
        html = `<div>${info.object.properties.name}</div>`;
      }
    }
    if (info?.layer?.id === 'layer-vessels' || info?.layer?.id === 'layer-atons') {
      let vesselsInfoHtml = null;
      const lastUploadClass = isDataOld ? styles.date_old : '';
      const motionDataClass = isDataOld ? styles.motion_data_old : '';
      if (info.object.registryName || info.object?.name) {
        vesselsInfoHtml = `<div class='${styles.bold}'>${info.object.registryName || info.object.name}</div>`;
      } else if (info.object?.mmsi) {
        vesselsInfoHtml = `<div class='${styles.bold}'>${info.object.mmsi}</div>`;
      }
      if (info.object?.registrySpecialType === 'ATON') {
        vesselsInfoHtml += `<div class='${styles.normal}'>${t('Aton')}</div>`;
      } else if (info.object?.meta?.typeGroup) {
        vesselsInfoHtml += `<div class='${styles.normal}'>${info.object.meta.typeGroup}</div>`;
      }
      if (info.object?.destination && info.object?.registrySpecialType !== 'ATON') {
        vesselsInfoHtml += `<div class='${styles.normal}'>${info.object.destination}</div>`;
      }
      if (info.object?.cog != null && info.object?.sog != null) {
        vesselsInfoHtml += `<div class='${motionDataClass} ${styles.bold}'>${info.object.cog}&deg; / ${info.object.sog.toFixed(2)} ${t('VesselSpeedUnit')}</div>`;
      }
      if (info.object?.t) {
        vesselsInfoHtml += `<div class='${lastUploadClass} ${styles.normal}'>${isLocalTz ? moment(info.object?.t).locale('en').format(`DD.MM.YYYY — ${timeFormat}`) : moment(info.object?.t).utc().locale('en').format(`DD.MM.YYYY — ${timeFormat} (UTC)`)}</div>`;
      }
      html = vesselsInfoHtml ? `<div class='${styles.overlay_info}'>${vesselsInfoHtml}</div>` : null;
    }
    if (info?.layer?.id === 'layer-ports' && zoom <= 8) {
      if (info.object.name) {
        html = `<div>${info.object.name}</div>`;
      }
    }
    if (info?.layer?.id === 'layer-terminals' && zoom < 13) {
      if (info.object.code) {
        html = `<div>${info.object.code}</div>`;
      }
    }
    if (info?.layer?.id === 'route-points-layer') {
      const cogText = info.object?.from?.cog !== undefined ? `${info.object?.from?.cog}&deg;` : `&mdash;`;
      const sogText =
        info.object?.from?.sog !== undefined ? `${info.object?.from?.sog?.toFixed(2)} ${t('VesselSpeedUnit')}` : `&mdash;`;
      html = `<div>${cogText} / ${sogText}
      <div>${isLocalTz ? moment(info.object?.from?.t).locale('en').format(`DD.MM.YYYY — ${timeFormat}`) : moment(info.object?.from?.t).utc().locale('en').format(`DD.MM.YYYY — ${timeFormat} (UTC)`)}</div>
      </div>`;
    }
  }

  return html
    ? {
        html,
        className: `${styles.tooltip}`,
      }
    : null;
};
